import { observer } from "mobx-react-lite";
import { useTranslations } from "next-intl";

import { Subtitle } from "@/components/dialog/DialogLayout";
import { useIsMyDoc } from "@/utils/useIsMyDoc";

import { CopyPublicLink } from "../components/CopyPublicLink";
import { QRCodeContent } from "../components/QRCodeContent";
import { SearchUserContent } from "../components/SearchUserContent";

import type { DocumentModel } from "@/models/DocumentModel";

export const ShareContent = observer(function ShareContent({
  doc,
  tab,
}: {
  doc: DocumentModel;
  tab: "link" | "qr";
}) {
  const t = useTranslations();
  const isMyDoc = useIsMyDoc(doc);
  return (
    <div className="flex flex-col">
      <Subtitle
        title={
          tab === "link"
            ? t("share.shareDocument", {
                docTitle: doc.title ? `“${doc.title}”` : "",
              })
            : t("share.shareByQRCode")
        }
        className="mb-1.5 mr-5 p-1 truncate"
      />
      {!isMyDoc && tab === "link" && <CopyPublicLink doc={doc} />}
      {tab === "link" && <SearchUserContent doc={doc} />}
      {tab === "qr" && <QRCodeContent doc={doc} />}
    </div>
  );
});
